<template>
  <a-drawer width="55vw" :label-col="4" :wrapper-col="14" :visible="open" @cancel="onClose" @close="onClose">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider>
    <a-form-model ref="form" :label-col="labelCol" :wrapper-col="wrapperCol" :model="form" :rules="rules">
      <a-form-model-item prop="studyId">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.活动id') }}<template slot="title">{{ $t('线下报名.活动id') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.studyId" :placeholder="$t('通用.输入.请输入') + $t('线下报名.活动id')" />
      </a-form-model-item>
      <a-form-model-item prop="userId">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.') }}<template slot="title">{{ $t('线下报名.') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.userId" :placeholder="$t('通用.输入.请输入') + $t('线下报名.')" />
      </a-form-model-item>
      <a-form-model-item prop="userName">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.用户姓名') }}<template slot="title">{{ $t('线下报名.用户姓名') }}</template>
          </a-tooltip>
        </span>
        <a-input
          v-model="form.userName"
          :maxLength="20"
          :placeholder="$t('通用.输入.请输入') + $t('线下报名.用户姓名')"
        />
      </a-form-model-item>
      <a-form-model-item prop="mobile">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.手机号') }}<template slot="title">{{ $t('线下报名.手机号') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.mobile" :maxLength="30" :placeholder="$t('通用.输入.请输入') + $t('线下报名.手机号')" />
      </a-form-model-item>
      <a-form-model-item prop="money">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.支付金额') }}<template slot="title">{{ $t('线下报名.支付金额') }}</template>
          </a-tooltip>
        </span>
        <a-input v-model="form.money" :placeholder="$t('通用.输入.请输入') + $t('线下报名.支付金额')" />
      </a-form-model-item>
      <a-form-model-item prop="payType">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.1微信支付 2支付宝')
            }}<template slot="title">{{ $t('线下报名.1微信支付 2支付宝') }}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-form-model-item prop="status">
        <span slot="label">
          <a-tooltip>
            {{ $t('线下报名.0未支付，1支付成功，2支付失败')
            }}<template slot="title">{{ $t('线下报名.0未支付，1支付成功，2支付失败') }}</template>
          </a-tooltip>
        </span>
      </a-form-model-item>
      <a-modal :visible="previewImageVisible" :footer="null" @cancel="previewImageCancel">
        <img alt="example" style="width: 100%" :src="previewUrl" />
      </a-modal>
      <a-modal :visible="previewVideoVisible" :footer="null" @cancel="previewVideoCancel">
        <video
          style="width: 100%"
          :src="previewUrl"
          ref="myVideo"
          :poster="previewUrl + '?x-oss-process=video/snapshot,t_0,f_jpg'"
          :controls="true"
        ></video>
      </a-modal>
      <div class="bottom-control">
        <a-space>
          <a-button type="primary" :loading="submitLoading" @click="submitForm">
            {{ $t('通用.按钮.保存') }}
          </a-button>
          <a-button type="dashed" @click="cancel">
            {{ $t('通用.按钮.取消') }}
          </a-button>
        </a-space>
      </div>
    </a-form-model>
  </a-drawer>
</template>

<script>
import { getApply, addApply, updateApply } from '@/api/study/apply'
import { mapGetters } from 'vuex'
import CustomDictTag from '@/components/DictCustomTag'
import { generateFilePath, uploadObject } from '@/api/tool/oss'

export default {
  name: 'CreateForm',
  props: {},
  components: {
    CustomDictTag,
  },
  data() {
    return {
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      submitLoading: false,
      formTitle: '',
      previewImageVisible: false,
      previewUrl: '',
      previewVideoVisible: false,
      loading: '',
      // 表单参数
      form: {
        id: null,

        studyId: null,

        userId: null,

        userName: null,

        mobile: null,

        money: null,

        payType: null,

        status: 0,

        createTime: null,
      },
      // 1增加,2修改
      formType: 1,
      open: false,
      rules: {},
    }
  },
  filters: {},
  created() {},
  computed: {
    ...mapGetters(['customDict']),
  },
  watch: {},
  mounted() {},
  methods: {
    onClose() {
      this.open = false
      this.reset()
    },
    // 取消按钮
    cancel() {
      this.open = false
      this.reset()
    },
    previewImageCancel() {
      this.previewImageVisible = false
    },
    previewVideoCancel() {
      this.previewVideoVisible = false
    },
    // 表单重置
    reset() {
      this.formType = 1
      this.form = {
        id: null,
        studyId: null,
        userId: null,
        userName: null,
        mobile: null,
        money: null,
        payType: null,
        status: 0,
        createTime: null,
      }
    },
    /** 新增按钮操作 */
    handleAdd(row) {
      this.reset()
      this.formType = 1
      this.open = true
      this.formTitle = this.$t('通用.文本.添加')
    },
    /** 修改按钮操作 */
    handleUpdate(row, ids) {
      this.reset()
      this.formType = 2
      const id = row ? row.id : ids
      getApply({ id: id }).then((response) => {
        this.form = response.data
        this.open = true
        this.formTitle = this.$t('通用.文本.修改')
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submitLoading = true
          let message = ''
          if (this.form.id !== undefined && this.form.id !== null) {
            message = this.$t('通用.文本.修改成功')
            updateApply(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          } else {
            message = this.$t('通用.文本.修改成功')
            addApply(this.form)
              .then((response) => {
                this.$message.success(message, 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
